import {VisualBox} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/VisualBox';
import {Repeater} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/Repeater';

export interface VisualBoxVisitor
{
    onVisualBox(visualBox:VisualBox | null, repeater:Repeater):boolean | undefined;
}

export class VisualBoxTraverser
{
    public static visit(visualBoxes:Array<VisualBox>, visitor:VisualBoxVisitor):boolean
    {
        if( !visualBoxes || !visualBoxes.length )
            return false;

        for( const visualBox of visualBoxes )
            for( const repeater of visualBox.repeaters )
            {
                if( visitor.onVisualBox(visualBox, repeater) )
                    return true;

                if( VisualBoxTraverser.visit(visualBox.repeatedData.get(repeater.index).children, visitor) )
                    return true;
            }

        return false;
    }
}
